// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  API_URL: '#{API_URL}#',
  PATH_NAS: '#{PATH_NAS}#',
  PATH_NAS_SOX: '#{PATH_NAS_SOX}#',
  azureConfig: {
    clientId: '#{CLIENT_ID}#',
    api: '#{AZURE_API}#',
    protectedResourceMap: '#{PROTECTED_RESOURCE_MAP}#',
    redirectUri: '/',
    redirectUriLogout: '#{REDIRECT_URI_LOGOUT}#',
    tenantId: '#{TENANT_ID}#',
    authority: 'https://login.microsoftonline.com/#{TENANT_ID}#',
  },
  securityGroupsMapping: {
    Auditor: '#{AUDITOR_GROUP}#',
    Gerente: '#{GERENTE_GROUP}#',
    Administrador: '#{ADMIN_GROUP}#',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
